module.exports = __webpack_public_path__ + "static/img/invite-btn.2f4b324.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite-btn.png
// module id = U3rE
// module chunks = 0